import { localContentPrefix } from '../../../config';
import { AggregationResponseOut } from '../../../store/api';
import { http } from '../../axios';
import { FetchAggregationsOptions } from '../../listContent/fetchAggregations';

type Options = FetchAggregationsOptions;

const url = `${localContentPrefix}/v1/localcollectioncontent/list/:kind`;

export const fetchLocalContentCollectionAggregations = (options: Options): Promise<AggregationResponseOut> => {
    return http
        .post<AggregationResponseOut>(url, options.filters, {
            pathParams: {
                kind: 'aggregation'
            }
        })
        .then(response => response.data);
};
